<!-- new template -->
<template>
  <div class="threeInfo">
    <div class="case-title">
      <span class="case-title-t" style="color:#fff">检索大学生个人数据报告</span>
      <span class="case-title-b" style="color:#fff">PERSONAL DATA REPORT OF COLLEGE STUDENTS</span>
    </div>
    <div class="case-main">
      <div class="case-search">
        <div class="case-search-box">
          <el-input
            placeholder="输入编码ID或身份证号查询"
            v-model="searchModel"
            size="small"
            class="input-with-select"
            @keyup.enter.native="tipswords()"
          ></el-input>
          <i class="el-icon-search" @click="tipswords()"></i>
          <!-- 刷新按钮 -->
          <div class="list-refresh" @click="reset()">
            <i class="list-refresh-icon el-icon-refresh" id="list-refresh-icon"></i>
          </div>
        </div>
      </div>
    </div>
    <div id="stu-list-wrap" v-show="showThree" class="height:600px">
      <div class="info-body">
        <div id="container"></div>
        <div id="menu">
          <!-- <button id="table">表面</button>
  <button id="sphere">球体</button>
  <button id="helix">螺旋</button>
          <button id="grid">网格</button>-->
        </div>
      </div>
    </div>
    <!-- 弹窗提示  -->
    <transition name="fade">
      <div class="modelBox" v-if="show">
        <div class="model_text">您暂未获得查阅权限</div>
      </div>
    </transition>
  </div>
</template>

<script>
import { Input } from 'element-ui'
import userInfo from '../../../static/userinfo.json'
/* eslint-disable */
var camera, scene, renderer
var controls

var objects = []
var targets = { table: [], sphere: [], helix: [], grid: [] }
export default {
  name: 'three-info',
  data () {
    return {
      searchModel: '', // dale参数
      show: false, // dale参数
      showThree: false,
      table: [
        'H', 'Hydrogen', '1.00794', 1, 1,
        'He', 'Helium', '4.002602', 2, 1,
        'Li', 'Lithium', '#6.941', 3, 1,
        'Be', 'Beryllium', '9.012182', 4, 1,
        'B', 'Boron', '#10.811', 5, 1,
        'C', 'Carbon', '#12.0107', 6, 1,
        'C', 'Carbon', '#12.0107', 7, 1,
        'C', 'Carbon', '#12.0107', 8, 1,
        'C', 'Carbon', '#12.0107', 9, 1,
        'C', 'Carbon', '#12.0107', 10, 1,
        'C', 'Carbon', '#12.0107', 11, 1,
        'C', 'Carbon', '#12.0107', 12, 1,
        'C', 'Carbon', '#12.0107', 13, 1,
        'C', 'Carbon', '#12.0107', 14, 1,
        'C', 'Carbon', '#12.0107', 15, 1,
        'C', 'Carbon', '#12.0107', 16, 1,
        // 'C', 'Carbon', '#12.0107', 17, 1,
        // 'C', 'Carbon', '#12.0107', 18, 1,
        'N', 'Nitrogen', '#14.0067', 1, 2,
        'O', 'Oxygen', '#15.9994', 2, 2,
        'F', 'Fluorine', '18.9984032', 3, 2,
        'Ne', 'Neon', '#20.1797', 4, 2,
        'Na', 'Sodium', '22.98976...', 5, 2,
        'Mg', 'Magnesium', '#24.305', 6, 2,
        'N', 'Nitrogen', '#14.0067', 7, 2,
        'O', 'Oxygen', '#15.9994', 8, 2,
        'F', 'Fluorine', '18.9984032', 9, 2,
        'Ne', 'Neon', '#20.1797', 10, 2,
        'Na', 'Sodium', '22.98976...', 11, 2,
        'Mg', 'Magnesium', '#24.305', 12, 2,
        'N', 'Nitrogen', '#14.0067', 13, 2,
        'O', 'Oxygen', '#15.9994', 14, 2,
        'F', 'Fluorine', '18.9984032', 15, 2,
        'Ne', 'Neon', '#20.1797', 16, 2,
        // 'Na', 'Sodium', '22.98976...', 17, 2,
        // 'Mg', 'Magnesium', '#24.305', 18, 2,
        'Al', 'Aluminium', '26.9815386', 1, 3,
        'Si', 'Silicon', '#28.0855', 2, 3,
        'P', 'Phosphorus', '30.973762', 3, 3,
        'S', 'Sulfur', '#32.065', 4, 3,
        'Cl', 'Chlorine', '#35.453', 5, 3,
        'Ar', 'Argon', '#39.948', 6, 3,
        'Al', 'Aluminium', '26.9815386', 7, 3,
        'Si', 'Silicon', '#28.0855', 8, 3,
        'P', 'Phosphorus', '30.973762', 9, 3,
        'S', 'Sulfur', '#32.065', 10, 3,
        'Cl', 'Chlorine', '#35.453', 11, 3,
        'Ar', 'Argon', '#39.948', 12, 3,
        'Al', 'Aluminium', '26.9815386', 13, 3,
        'Si', 'Silicon', '#28.0855', 14, 3,
        'P', 'Phosphorus', '30.973762', 15, 3,
        'S', 'Sulfur', '#32.065', 16, 3,
        // 'Cl', 'Chlorine', '#35.453', 17, 3,
        // 'Ar', 'Argon', '#39.948', 18, 3,
        'K', 'Potassium', '#39.948', 1, 4,
        'Ca', 'Calcium', '#40.078', 2, 4,
        'Sc', 'Scandium', '44.955912', 3, 4,
        'Ti', 'Titanium', '#47.867', 4, 4,
        'V', 'Vanadium', '#50.9415', 5, 4,
        'Cr', 'Chromium', '#51.9961', 6, 4,
        'K', 'Potassium', '#39.948', 7, 4,
        'Ca', 'Calcium', '#40.078', 8, 4,
        'Sc', 'Scandium', '44.955912', 9, 4,
        'Ti', 'Titanium', '#47.867', 10, 4,
        'V', 'Vanadium', '#50.9415', 11, 4,
        'Cr', 'Chromium', '#51.9961', 12, 4,
        'K', 'Potassium', '#39.948', 13, 4,
        'Ca', 'Calcium', '#40.078', 14, 4,
        'Sc', 'Scandium', '44.955912', 15, 4,
        'Ti', 'Titanium', '#47.867', 16, 4,
        // 'V', 'Vanadium', '#50.9415', 17, 4,
        // 'Cr', 'Chromium', '#51.9961', 18, 4,
        'Mn', 'Manganese', '54.938045', 1, 5,
        'Fe', 'Iron', '#55.845', 2, 5,
        'Co', 'Cobalt', '58.933195', 3, 5,
        'Ni', 'Nickel', '#58.6934', 4, 5,
        'Cu', 'Copper', '#63.546', 5, 5,
        'Zn', 'Zinc', '#65.38', 6, 5,
        'Mn', 'Manganese', '54.938045', 7, 5,
        'Fe', 'Iron', '#55.845', 8, 5,
        'Co', 'Cobalt', '58.933195', 9, 5,
        'Ni', 'Nickel', '#58.6934', 10, 5,
        'Cu', 'Copper', '#63.546', 11, 5,
        'Zn', 'Zinc', '#65.38', 12, 5,
        'Mn', 'Manganese', '54.938045', 13, 5,
        'Fe', 'Iron', '#55.845', 14, 5,
        'Co', 'Cobalt', '58.933195', 15, 5,
        'Ni', 'Nickel', '#58.6934', 16, 5,
        // 'Cu', 'Copper', '#63.546', 17, 5,
        // 'Zn', 'Zinc', '#65.38', 18, 5,
        'Ga', 'Gallium', '#69.723', 1, 6,
        'Ge', 'Germanium', '#72.63', 2, 6,
        'As', 'Arsenic', '#74.9216', 3, 6,
        'Ga', 'Gallium', '#69.723', 4, 6,
        'Ge', 'Germanium', '#72.63', 5, 6,
        'As', 'Arsenic', '#74.9216', 6, 6,
        'Ga', 'Gallium', '#69.723', 7, 6,
        'Ge', 'Germanium', '#72.63', 8, 6,
        'As', 'Arsenic', '#74.9216', 9, 6,
        'Ga', 'Gallium', '#69.723', 10, 6,
        'Ge', 'Germanium', '#72.63', 11, 6,
        'As', 'Arsenic', '#74.9216', 12, 6,
        'As', 'Arsenic', '#74.9216', 13, 6,
        'As', 'Arsenic', '#74.9216', 14, 6,
        'As', 'Arsenic', '#74.9216', 15, 6,
        'As', 'Arsenic', '#74.9216', 16, 6,
        // 'As', 'Arsenic', '#74.9216', 17, 6,
        // 'As', 'Arsenic', '#74.9216', 18, 6
      ]
    }
  },
  watch: {
    showThree (val) {
      if (val === true) {
        this.init()
        this.animate()
      }
    }

  },
  components: {
    'el-input': Input
  },
  mounted () {
    // 页面滚动事件
    window.addEventListener('scroll', this.showComp, true)
  },
  methods: {
    reset () {
      this.searchModel = ''
      document.getElementById('container').innerHTML = ''
      this.init()
      this.animate()
      // 刷新按钮旋转特效
      let classlist = document.getElementById('list-refresh-icon').getAttribute('class')
      classlist = classlist.concat(' xuanzhuan')
      document.getElementById('list-refresh-icon').setAttribute('class', classlist)
      window.setTimeout(() => {
        let classlist = document.getElementById('list-refresh-icon').getAttribute('class')
        classlist = classlist.replace(' xuanzhuan', '');
        document.getElementById('list-refresh-icon').setAttribute('class', classlist);
      }, 1000)
    },
    // 初始化
    init () {
      var dws = document.body.clientWidth
      document.getElementsByClassName('info-body')[0].style.width = (dws - 50) + 'px'
      camera = new THREE.PerspectiveCamera(40, dws / 500, 1, 10000)
      camera.position.z = 2700

      scene = new THREE.Scene()

      // table

      for (var i = 0; i < this.table.length; i += 5) {
        var element = document.createElement('div')
        element.className = 'element'
        // element.style.backgroundColor = 'rgba(0,0,0,' + (Math.random() * 0.5 + 0.4) + ')'
        element.style.backgroundColor = '#333333'

        var number = document.createElement('div')
        number.className = 'number'
        number.textContent = (i / 5) + 1
        element.appendChild(number)

        var symbol = document.createElement('img')
        symbol.className = 'atvar'
        symbol.textContent = this.table[i]
        symbol.src = userInfo[Math.floor(Math.random() * 1000)]
        element.appendChild(symbol)

        let firstName = ['刘', '张', '吴', '郑', '孙', '李', '王', '梁', '何', '陈', '谭', '周', '陆', '吕', '冯', '甘', '黄', '蒋', '黎', '廖', '莫', '赵', '欧', '谢', '苏', '杨', '钟', '朱', '叶', '徐']
        let secondName = ['星', '心', '凉', '白', '小', '笑', '环', '幻', '依', '林', '梅', '阳', '妮', '博', '冰', '波', '贝', '嘉', '雯', '唯', '萱', '颖', '阅', '韵', '雨', '乐', '鸿', '梵', '桦', '静']
        let lastName = ['文', '森', '林', '峰', '光', '', '飞', '宝', '', '木', '林', '梅', '阳', '妮', '博', '冰', '波', '']
        var details = document.createElement('div')
        details.className = 'details'
        details.innerHTML = firstName[Math.floor(Math.random() * firstName.length)] + secondName[Math.floor(Math.random() * secondName.length)] + lastName[Math.floor(Math.random() * lastName.length)]
        element.appendChild(details)

        var object = new THREE.CSS3DObject(element)
        object.position.x = Math.random() * 4000 - 2000 // 随机X轴元素位置
        object.position.y = Math.random() * 2000 - 1000 // 随机Y轴元素位置
        object.position.z = Math.random() * 2000 - 1000 // 随机Z轴元素位置
        scene.add(object)

        objects.push(object)

        object = new THREE.Object3D()
        object.position.x = (this.table[i + 3] * 240) - 2100
        object.position.y = -(this.table[i + 4] * 320) + 1100

        targets.table.push(object)
      }

      //
      var dw = document.body.clientWidth - 25
      renderer = new THREE.CSS3DRenderer()
      renderer.setSize(dw, 600)
      renderer.domElement.style.position = 'absolute'
      // renderer.domElement.style.left = '0px'
      document.getElementById('container').appendChild(renderer.domElement)

      //

      controls = new THREE.TrackballControls(camera, renderer.domElement)
      controls.rotateSpeed = 0.5
      controls.minDistannce = 500
      controls.maxDistance = 6000
      controls.addEventListener('change', this.render)

      this.transform(targets.table, 5000)

      //

      // window.addEventListener('resize', onWindowResize, false)
    },
    animate () {
      requestAnimationFrame(this.animate)
      TWEEN.update()
      // controls.update()
    },
    transform (targets, duration) {
      TWEEN.removeAll()

      for (var i = 0; i < objects.length; i++) {
        var object = objects[i]
        var target = targets[i]

        new TWEEN.Tween(object.position)
          .to({ x: target.position.x, y: target.position.y, z: target.position.z }, Math.random() * duration + duration)
          .easing(TWEEN.Easing.Exponential.InOut)
          .start()

        new TWEEN.Tween(object.rotation)
          .to({ x: target.rotation.x, y: target.rotation.y, z: target.rotation.z }, Math.random() * duration + duration)
          .easing(TWEEN.Easing.Exponential.InOut)
          .start()
      }

      new TWEEN.Tween(this)
        .to({}, duration * 2)
        .onUpdate(this.render)
        .start()
    },
    render () {
      renderer.render(scene, camera)
    },
    // 大学生个人数据报告搜索点击事件
    tipswords () {
      this.toops()
    },
    // 提示弹窗控制
    toops () {
      if (this.show === true) {
        return false
      } else {
        this.show = true
        window.setTimeout(() => {
          this.show = false
        }, 1200)
      }
    },
    // 滚动函数（显隐学生列表模块）
    showComp () {
      let dom = document.getElementById('stu-list-wrap')
      if (dom) {
        if (this.getElementTopLeft(dom).top + dom.clientHeight > window.pageYOffset && window.pageYOffset + window.innerHeight > this.getElementTopLeft(dom).top) {
          this.showThree = true
        }
      }
    },
    // 判断当前dom元素是否在页面可视区域展示
    getElementTopLeft (obj) {
      var top = 0
      var left = 0
      while (obj) {
        top += obj.offsetTop
        left += obj.offsetLeft
        obj = obj.offsetParent
      }
      return { top: top, left: left }
    }
  }
}

</script>
<style lang='css'>
@import "three.css";
</style>
<style lang="scss" scoped>
// 头部所有样式
.threeInfo {
  .case-title {
    width: 100%;
    height: 120px;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: center;

    .case-title-t {
      padding: 8px 0;
      font-size: 16px;
      color: #333;
      font-weight: 700;
    }

    .case-title-b {
      padding: 8px 0;
      font-size: 12px;
      font-weight: 400;
      color: #999999;
    }
  }

  .case-main {
    margin: 0 auto;
    box-sizing: border-box;
    position: relative;

    .swiper-container {
      // width: 1200px;
      height: 100%;
      margin: 0 auto;
      box-sizing: border-box;

      .swiper-pagination {
        position: absolute;
        bottom: 0px;

        .swiper-pagination-bullet {
          width: 6px;
          height: 4px;
          border-radius: 0;
          background-color: #666;
        }

        .swiper-pagination-bullet-active {
          background-color: #333;
        }
      }

      .swiper-slide {
        width: 25%;
        height: 300px;
        padding: 15px;
        box-sizing: border-box;
        position: relative;

        .case-msg-img {
          width: 100%;
          height: 100%;
          background-repeat: no-repeat;
          background-size: cover;
          background-position: center center;
          position: relative;

          .case-msg-zz {
            background-image: url(../../assets/img/icon-sponsor/zz.png);
            background-repeat: no-repeat;
            background-size: 100% 100%;
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
            bottom: 0;
            right: 0;
            z-index: 2;
          }
        }

        .case-messagebox {
          width: 100%;
          height: 100%;
          padding: 50px 58px 50px 38px;
          box-sizing: border-box;
          position: absolute;
          top: 0;
          left: 0;
          display: flex;
          z-index: 5;
          flex-direction: column;
          justify-content: flex-end;
          align-items: flex-start;

          .case-msg-title {
            font-size: 13px;
            color: #ffffff;
            font-weight: 700;
            line-height: 22px;
            padding-bottom: 10px;
          }

          .case-msg-more {
            a {
              font-size: 12px;
              font-weight: 400;
              color: #dddddd;
              line-height: 24px;
            }
          }
        }
      }
    }

    .el-icon-arrow-left {
      width: 60px;
      height: 60px;
      border-radius: 50%;
      background-color: rgba(0, 0, 0, 0.05);
      position: absolute;
      top: 35%;
      left: 0;
      color: rgba(0, 0, 0, 0.3);
      display: flex;
      font-size: 40px;
      justify-content: center;
      align-items: center;
      cursor: pointer;
    }

    .el-icon-arrow-left:hover {
      color: rgba(0, 0, 0, 0.5);
    }

    .el-icon-arrow-right {
      width: 60px;
      height: 60px;
      border-radius: 50%;
      background-color: rgba(0, 0, 0, 0.05);
      position: absolute;
      top: 35%;
      right: 0;
      color: rgba(0, 0, 0, 0.3);
      display: flex;
      font-size: 40px;
      justify-content: center;
      align-items: center;
      cursor: pointer;
    }

    .el-icon-arrow-right:hover {
      color: rgba(0, 0, 0, 0.5);
    }
  }
}
.case-search {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 40px;
  margin-top: 20px;

  .case-search-box {
    width: 500px;
    // height: 40px;
    position: relative;
    .list-refresh {
      height: 32px;
      width: 32px;
      background-color: #fff;
      position: absolute;
      z-index: 100;
      top: 0;
      right: -65px;
      border-radius: 50%;
      box-shadow: 0 0 4px 1px #dedede;
      cursor: pointer;
      .list-refresh-icon {
        width: 100%;
        height: 100%;
        line-height: 33px;
        position: absolute;
        top: 0;
        left: 0;
        font-size: 20px;
        color: #2178ec;
        display: inherit;
        text-align: center;
      }
    }
  }

  i {
    width: 40px;
    height: 100%;
    display: inline-block;
    font-size: 22px;
    color: #2178ec;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    right: 5px;
    top: 0;
    z-index: 2;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/threeinfo/threeInfo.vue